import { cloneDeep } from 'lodash'

export const deepCopy = <T>(value: T): T => cloneDeep(value)
